import { ContactsListActions } from '../ContactsListActions/ContactsListActions';
import { FilterChips } from '../FilterChips';
import { SearchCityStateFilter } from '../SearchCityStateFilter/SearchCityStateFilter';
import { IPageHeaderProps } from './PageHeader.types';
import { ContactsHeader } from '../ContactsHeader/ContactsHeader';

export const PageHeader = ({ actionsListProps }: IPageHeaderProps) => {
  const largeWidthScreen = window ? window.innerWidth > 600 : false;
  return (
    <>
      {largeWidthScreen && <ContactsHeader />}
      <div className="contact-header-utility-buttons-container">
        <section className="contact-header-search-container">
          <SearchCityStateFilter />
        </section>
        <ContactsListActions actionListProps={actionsListProps} />
      </div>
      <FilterChips />
      {!actionsListProps.cardView && <div className="header-bottom-border"></div>}
    </>
  );
};
